import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../Translations/LenguageContext";
import FormatDateTime from "../../../Functions/FormatDate";

const GeoTopicModal = ({ show, handleClose, openTopic }) => {
    const { t } = useLanguage()

    return (
        <Modal show={show} centered onHide={handleClose}>
            <div className="modal_header">
                <p className="modal_header_title">{t.geo.topic_info}</p>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">

                    <label className="input_label">ID</label>
                    <div className="input_value">{openTopic.id}</div>
                    
                    <label className="input_label">{t.geo.topic}</label>
                    <div className="input_value">{openTopic.name}</div>

                    <label className="input_label">{t.description}</label>
                    <div className="input_value">{openTopic.description}</div>

                    <label className="input_label">{t.geo.intent_type}</label>
                    <div className="input_value">{t.geo[openTopic.intent_type]}</div>

                    <label className="input_label">{t.geo.context_id}</label>
                    <div className="input_value">{openTopic.context_id}</div>

                    {/* <label className="input_label">source_page_ids</label>
                    <div className="input_value">{openTopic.source_page_ids}</div> */}

                    <label className="input_label">{t.created_at}</label>
                    <div className="input_value">{FormatDateTime(openTopic.created_at)}</div>

                    {/* <label className="input_label">{t.updated_at}</label> */}
                    {/* <div className="input_value">{FormatDateTime(openTopic.updated_at)}</div> */}
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GeoTopicModal;